/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RealizedDimensionDelta } from './RealizedDimensionDelta';
import {
    RealizedDimensionDeltaFromJSON,
    RealizedDimensionDeltaFromJSONTyped,
    RealizedDimensionDeltaToJSON,
    RealizedDimensionDeltaToJSONTyped,
} from './RealizedDimensionDelta';

/**
 * 
 * @export
 * @interface RecordPlanDimensionRealizationRequest
 */
export interface RecordPlanDimensionRealizationRequest {
    /**
     * 
     * @type {Array<RealizedDimensionDelta>}
     * @memberof RecordPlanDimensionRealizationRequest
     */
    deltas: Array<RealizedDimensionDelta>;
    /**
     * 
     * @type {string}
     * @memberof RecordPlanDimensionRealizationRequest
     */
    effectTenantId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RecordPlanDimensionRealizationRequest
     */
    force?: boolean;
}

/**
 * Check if a given object implements the RecordPlanDimensionRealizationRequest interface.
 */
export function instanceOfRecordPlanDimensionRealizationRequest(value: object): value is RecordPlanDimensionRealizationRequest {
    if (!('deltas' in value) || value['deltas'] === undefined) return false;
    return true;
}

export function RecordPlanDimensionRealizationRequestFromJSON(json: any): RecordPlanDimensionRealizationRequest {
    return RecordPlanDimensionRealizationRequestFromJSONTyped(json, false);
}

export function RecordPlanDimensionRealizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordPlanDimensionRealizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'deltas': ((json['deltas'] as Array<any>).map(RealizedDimensionDeltaFromJSON)),
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
        'force': json['force'] == null ? undefined : json['force'],
    };
}

export function RecordPlanDimensionRealizationRequestToJSON(json: any): RecordPlanDimensionRealizationRequest {
    return RecordPlanDimensionRealizationRequestToJSONTyped(json, false);
}

export function RecordPlanDimensionRealizationRequestToJSONTyped(value?: RecordPlanDimensionRealizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deltas': ((value['deltas'] as Array<any>).map(RealizedDimensionDeltaToJSON)),
        'effectTenantId': value['effectTenantId'],
        'force': value['force'],
    };
}

